import { render, staticRenderFns } from "./VotingRightsPreview.vue?vue&type=template&id=ce356088"
import script from "./VotingRightsPreview.vue?vue&type=script&lang=js"
export * from "./VotingRightsPreview.vue?vue&type=script&lang=js"
import style0 from "./VotingRightsPreview.vue?vue&type=style&index=0&id=ce356088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports